module.exports = __webpack_public_path__ + "img/starting-learning-journey-RWD.cb395ba8.svg";